import React from "react";
import { useTheme, useMediaQuery } from "@mui/material";

const Hidden = ({ children, mdDown, smDown, lgDown, mdUp, smUp, lgUp }) => {
  const theme = useTheme();

  // Sempre chamados, na mesma ordem
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));

  let hide = false;

  if (mdDown && (isSm || isXs)) hide = true;
  if (smDown && isXs) hide = true;
  if (lgDown && (isMd || isSm || isXs)) hide = true;

  if (mdUp && (isLg || isXl)) hide = true;
  if (smUp && (isMd || isLg || isXl)) hide = true;
  if (lgUp && isXl) hide = true;

  return hide ? null : <>{children}</>;
};

export default Hidden;
